module.exports = __webpack_public_path__ + "img/factors.aebbcf27.svg";